var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m141.37,395h-26.71L200.31,124.54c3.89-13.18,16.32-21.19,30.21-19.26,13.86,1.94,23.62,13.07,23.74,27.06v262.66h-25.46V132.46c0-.66-.02-1.71-1.82-1.97-1.81-.23-2.11.76-2.34,1.5l-83.28,263.01Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m272.48,237.12v-21.21c22.8,0,41.35-18.55,41.35-41.34s-18.55-41.34-41.35-41.34v-21.21c34.5,0,62.57,28.06,62.57,62.56s-28.07,62.56-62.57,62.56Z",
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m150.14,291l16.03,13.91c11.81-13.62,27.09-23.08,44.26-27.6v-21.74c-.8.17-1.62.23-2.41.42-22.54,5.25-42.55,17.36-57.87,35.01Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.98,253.15h-3.49v21.21h3.49c48.6,0,88.15,39.54,88.15,88.15v32.49h21.21v-32.49c0-60.3-49.06-109.36-109.36-109.36Z",
    fill: "#333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0b306f27b54f24ac0c2eb07bc0168da.svg";
export { ForwardRef as ReactComponent };